import { Box, Container, Typography } from "@mui/material";

import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import serviceAreaBg from "../../assets/images/service_area_bg.png";

const serviceAreas = ["Ajax", "Pickering", "Whitby", "Surrounding Areas"];

export default function ServiceAreas() {
  return (
    <Box
      sx={{
        position: "relative",

        overflow: "hidden",

        textAlign: "center",
        py: {
          xs: 4,
          md: 6,
        },

        px: {
          xs: 2.5,
          md: 5,
        },

        backgroundImage: `
            // linear-gradient(
            //   rgba(255,255,255,.82),
            //   rgba(248,251,255,.72)
            // ),
            url(${serviceAreaBg})
            `,

        backgroundSize: "cover",

        backgroundPosition: "center",

        backgroundRepeat: "no-repeat",
        backdropFilter: "blur(20px)",

        boxShadow: "0 25px 70px rgba(0,87,255,.08)",
      }}
    >
      <Container maxWidth="xl">
        <Box>
          {/* TOP BADGE */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <Box
              sx={{
                px: {
                  xs: 2,
                  md: 2.5,
                },

                py: 1,

                borderRadius: "50px",

                background: "rgba(255,255,255,.65)",

                backdropFilter: "blur(12px)",

                border: "1px solid rgba(0,87,255,.08)",

                color: "#0057ff",

                fontWeight: 700,

                textTransform: "uppercase",

                letterSpacing: "1px",

                fontSize: {
                  xs: "11px",
                  md: "12px",
                },
              }}
            >
              Service Areas
            </Box>
          </Box>

          {/* HEADING */}

          <Typography
            sx={{
              mt: 2,

              fontWeight: 900,

              color: "#07122F",

              lineHeight: 1.05,

              fontSize: {
                xs: "24px",
                sm: "30px",
                md: "48px",
                lg: "54px",
              },
            }}
          >
            Professional Care Services
            <Box
              component="span"
              sx={{
                display: "block",

                background: "linear-gradient(135deg,#0057FF,#4AA3FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              Serving Ajax & Surrounding Communities
            </Box>
          </Typography>

          {/* DESCRIPTION */}

          <Typography
            sx={{
              mt: 2,

              mx: "auto",

              maxWidth: "720px",

              color: "#64748B",

              lineHeight: 1.8,
              fontSize: {
                xs: "12px",
                md: "17px",
              },
            }}
          >
            Professional cleaning, dry cleaning, alterations, shoe repair,
            wedding dress care, custom printing and specialty services available
            across Ajax, Pickering, Whitby, Oshawa and nearby areas.
          </Typography>

          {/* ADDRESS CARD */}

          <Box
            sx={{
              mt: 4,

              mx: "auto",

              width: "fit-content",
              display: "flex",

              alignItems: "center",

              justifyContent: "center",

              gap: 1.2,

              px: {
                xs: 2,
                md: 3,
              },

              py: 1.8,

              borderRadius: "18px",

              background: "rgba(255,255,255,.80)",

              backdropFilter: "blur(15px)",

              border: "1px solid rgba(255,255,255,.9)",

              boxShadow: "0 12px 35px rgba(0,87,255,.06)",
            }}
          >
            <LocationOnIcon
              sx={{
                color: "#0057FF",
              }}
            />

            <Typography
              sx={{
                fontWeight: 700,

                color: "#12305F",

                fontSize: {
                  xs: "10px",
                  md: "15px",
                },
              }}
            >
              15 Westney Rd N, Unit 4A, Ajax, ON L1T 1P5
            </Typography>
          </Box>

          {/* AREA PILLS */}

          <Box
            sx={{
              mt: 4,

              display: "flex",

              flexWrap: "wrap",

              justifyContent: "center",

              gap: 1.2,
            }}
          >
            {serviceAreas.map((city) => (
              <Box
                key={city}
                sx={{
                  display: "flex",

                  alignItems: "center",

                  gap: 0.7,

                  px: {
                    xs: 1.8,
                    md: 2.2,
                  },

                  py: 1,

                  borderRadius: "50px",

                  background: "rgba(255,255,255,.82)",

                  backdropFilter: "blur(12px)",

                  border: "1px solid rgba(255,255,255,.9)",

                  boxShadow: "0 8px 25px rgba(0,87,255,.05)",

                  color: "#12305F",

                  fontWeight: 700,

                  fontSize: {
                    xs: "13px",
                    md: "14px",
                  },

                  transition: ".3s",

                  "&:hover": {
                    transform: "translateY(-3px)",

                    boxShadow: "0 15px 35px rgba(0,87,255,.10)",
                  },
                }}
              >
                <LocationOnIcon
                  sx={{
                    color: "#0057FF",

                    fontSize: 18,
                  }}
                />

                {city}
              </Box>
            ))}
          </Box>

          {/* BOTTOM BADGE */}

          <Box
            sx={{
              mt: 4,

              display: "inline-flex",

              alignItems: "center",

              gap: 1,

              px: 3,

              py: 1.2,

              borderRadius: "50px",

              background: "linear-gradient(135deg,#0057FF,#4AA3FF)",

              color: "#fff",

              fontWeight: 800,

              fontSize: "14px",

              boxShadow: "0 15px 40px rgba(0,87,255,.25)",
            }}
          >
            <LocalShippingIcon />
            Free Pickup & Delivery Available
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
